"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.KYFFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var KYFFactory = /** @class */ (function (_super) {
    __extends(KYFFactory, _super);
    function KYFFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    KYFFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    KYFFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    KYFFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    KYFFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    KYFFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return KYFFactory;
}(contracts_1.ContractFactory));
exports.KYFFactory = KYFFactory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_user",
                type: "address",
            },
        ],
        name: "Removed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_verified",
                type: "address",
            },
        ],
        name: "Verified",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_verifier",
                type: "address",
            },
        ],
        name: "VerifierSet",
        type: "event",
    },
    {
        constant: true,
        inputs: [],
        name: "count",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "isVerified",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_user",
                type: "address",
            },
        ],
        name: "remove",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address[]",
                name: "_users",
                type: "address[]",
            },
        ],
        name: "removeMultiple",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_verifier",
                type: "address",
            },
        ],
        name: "setVerifier",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "verifier",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_user",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "_v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "_r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "_s",
                type: "bytes32",
            },
        ],
        name: "verify",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
//# sourceMappingURL=KYFFactory.js.map